import { CSSProperties } from "@material-ui/core/styles/withStyles";
import { colors, greys } from "@clockwise/web-commons/src/styles/color.styles";
import { size } from "@clockwise/web-commons/src/styles/type.styles";
import spacing from "@clockwise/web-commons/src/styles/spacing.styles";

export const topLine: CSSProperties = {
  fontSize: 12,
  color: greys.slate,
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  lineHeight: 1.6,
  paddingBottom: 10,
};

// NEW STUFF
export const toplineNew: CSSProperties = {
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "center",
  fontSize: size.sm,
  color: greys.slate,
};

export const metaInfo: CSSProperties = {
  display: "flex",
  flexDirection: "row",
};

export const icon = {
  cursor: "pointer",
  color: greys.blueGrey,
  "&:hover": {
    color: greys.slate,
  },
} as CSSProperties;

export const interpunct: CSSProperties = {
  marginLeft: spacing.xxs,
  marginRight: spacing.xxs,
};

export const newText: CSSProperties = {
  color: colors.blueSky.darker,
  fontWeight: "bold",
};

export const styles = {
  icon,
};
